import type { GetPersonCertificationsRes } from "./-query/type";

type CertificationsTableRow = GetPersonCertificationsRes["items"][number];

// Certifications テーブルの列定義
export const Columns = {
  CERTIFICATION_NAME: "certificationName",
  CERTIFICATION_NUMBER: "certificationNumber",
  LAST_RENEWAL_DATE: "lastRenewalDate",
  VALID_TO: "validTo",
  RENEWAL_DEADLINE: "renewalDeadline",
} as const satisfies Record<string, keyof CertificationsTableRow>;
